import styles from "./AppHeader.module.css";
import pitermobileLogo from "../../images/pmlogo.png";
import telegramLogo from "../../images/telegramLogo.webp";
import whatsappLogo from "../../images/whatsappLogo.webp";
import menuIcon from "../../images/menuIcon.png";
import { useState } from "react";
import { NavLink } from 'react-router-dom';

export default function AppHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  
  let menuClickHandler = () => {
    setMenuOpen(!menuOpen)
    console.log(menuOpen)
    return
  }

  return (
    <header className={styles.header}>
      <a className={styles.header__logoContainer} href="/">
        <img className={styles.header__logo} src={pitermobileLogo} alt="Logo" />
        <h1 className={styles.header__logoText}>ПИТЕР МОБИЛЬ</h1>
      </a>
      <NavLink
        to="/"
        className={({ isActive }) => isActive ? styles.header__text_active : styles.header__text}
      >
        Продать авто
      </NavLink>
      <NavLink
        to="/подбор"
        className={({ isActive }) => isActive ? styles.header__text_active : styles.header__text}
      >
        Подбор
      </NavLink>
      <NavLink
        to="/контакты"
        className={({ isActive }) => isActive ? styles.header__text_active : styles.header__text}
      >
        Контакты
      </NavLink>
      <div className={styles.header__socialContainer}>
        <a href="https://t.me/Pitermobile_ru" className={styles.header__iconContainer}>
          <img className={styles.header__telegramIcon} src={telegramLogo} alt="Телеграм" />
        </a>
        <a href="https://wa.me/9939838998?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!" className={styles.header__iconContainer}>
          <img src={whatsappLogo} className={styles.header__whatsappIcon} alt="WhatsApp" />
        </a>
      </div>
      <p className={`${styles.header__text} ${styles.header__text_number}`}>8-993-983-89-98</p>
      <img className={styles.header__menuIcon} src={menuIcon} onClick={menuClickHandler} alt="Меню"></img>
      <div className={menuOpen?styles.popup:styles.popup_closed}>
        <div className={styles.menu__container}>
          <a className={styles.menu__link} href="/">Продать авто</a>
          <a className={styles.menu__link} href="/подбор">Подбор авто</a>
          <a className={styles.menu__link} href="/контакты">Контакты</a>
        </div>
      </div>
    </header>
  )
}